// see default-carousel.js for updated code